import React, { useEffect, useState,useContext } from 'react';
import { Link } from 'react-router-dom';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import { toast } from 'react-toastify';
import { Context } from '../../context/UserContext';



const Index = () => {

    const context = useContext(Context);
    const { readData } = useEntityCrud('AnswerWeights/getAll');
    const { statusData } = useEntityCrud('OpinionFactor/ChangeStatus');

    const [rows, setRows] = useState([]);

    const getData = () => {
        readData().then(({ data }) => {
            if (data.status)
                setRows(data.result);
        });
    }

    useEffect(() => {
        getData();
    }, [])


    const deActiveRow = (id, title) => {
         
        const postedData = {
            id,
            status: false,
            title: title
        };
        statusData(postedData).then(({ data }) => {
             
            if (data.status) {
                toast.success(' معیار نظرسنجی مورد نظر با موفقیت غیرفعال  شد');
                getData();
            } else
                data.errors?.map(error => toast.error(error.message));
        });
    }

    const activeRow = (id, title) => {
         
        const postedData = {
            id,
            status: true,
            title: title
        };
        statusData(postedData).then(({ data }) => {
             
            if (data.status) {
                toast.success(' معیار نظرسنجی مورد نظر با موفقیت فعال شد');
                getData();
            } else
                data.errors?.map(error => toast.error(error.message));
        });
    }


    return (
        <div className="card">
            <div className="card-header">
                <div className="card-title">  وزن امتیازات نظرسنجی </div>
            </div>
            <div className="card-body">

                {rows.length ? <table className="table table-bordered table-hover border text-nowrap text-md-nowrap">
                    <thead>
                        <tr>
                            <th>ردیف</th>
                            <th>عنوان</th>
                            <th>وزن</th>
                            <th>عملیات</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((item, index) => (

                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item.answerRank + " ستاره " || '-'} <span  > {`⭐`.repeat(item.answerRank)} </span>
                                </td>
                               
                                <td>{item.andwerPoints || '-'}</td>
                                <td className="btn-list">
                                    {context.checkHasPermission('update') ? <Link to={'update/' + item.id} title="ویرایش" className="btn btn-icon mb-0 btn-primary"><i className="fe fe-edit-2"></i></Link> : ''}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table> : <div className="alert alert-info"><p>وزن امتیازات نظرسنجی یافت نشد</p></div>}
            </div>
        </div >
    );
}

export default Index;